// CP-290 (AC7): HAL fares that looked like offer-code (invitation) fares are
// history only. The prices API leaves them out of `prices`, so they never
// reach the chart (no muted line either) or the Current / Lowest / Highest
// tiles, and lists the affected cabins in cruise_info.offer_only_cabins.
//
// The muted note under the chart (UI/UX copy on #230):
// * only when a cabin that is plotted right now has flagged rows;
// * names that cabin; no $, no number or count, never Lowest / Current;
// * hedged: the offer-code reading is inferred, not known.
const TAIL = 'looked like offer-code fares, not public prices, so they aren\'t charted.';

// Cabins named in the note: plotted AND flagged, in tile order (the
// Current / Lowest tiles above the chart, cheap -> premium) when given,
// else chart order. A cabin missing from tileOrder keeps chart order, last.
export function offerOnlyCabinsShown(plottedCabins, flaggedCabins, tileOrder) {
  if (!Array.isArray(plottedCabins) || !Array.isArray(flaggedCabins)) return [];
  const flagged = new Set(flaggedCabins.filter((c) => typeof c === 'string' && c));
  const seen = new Set();
  const shown = plottedCabins.filter((cabin) => {
    if (!flagged.has(cabin) || seen.has(cabin)) return false;
    seen.add(cabin);
    return true;
  });
  if (!Array.isArray(tileOrder)) return shown;
  const rank = (cabin) => {
    const i = tileOrder.indexOf(cabin);
    return i === -1 ? Infinity : i;
  };
  return shown
    .map((cabin, i) => ({ cabin, i }))
    .sort((a, b) => (rank(a.cabin) - rank(b.cabin)) || (a.i - b.i))
    .map(({ cabin }) => cabin);
}

// UI/UX copy (#230 re-review at e7945b6):
// * 1 cabin:  "Some earlier Neptune Suite prices looked like ..."
// * 2 cabins: "Some earlier Interior and Neptune Suite prices looked like ..." (tile order)
// * 3+:       "Some earlier prices in several cabins looked like ..."
export function offerOnlyNote(plottedCabins, flaggedCabins, tileOrder) {
  const shown = offerOnlyCabinsShown(plottedCabins, flaggedCabins, tileOrder);
  if (shown.length === 0) return '';
  if (shown.length === 1) return `Some earlier ${shown[0]} prices ${TAIL}`;
  if (shown.length === 2) return `Some earlier ${shown[0]} and ${shown[1]} prices ${TAIL}`;
  return `Some earlier prices in several cabins ${TAIL}`;
}
